import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = {
  class: "syndicated-badge"
};
const _hoisted_2 = {
  class: "syndicated-badge__logo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "syndicated-badge__text",
  "data-ui": "syndicated-badge-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsSyndicatedBadge",
  props: {
    logoUrl: {},
    companyName: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("img", {
        src: _ctx.logoUrl
      }, null, 8, _hoisted_3)]), createElementVNode("div", _hoisted_4, " Originally posted on " + toDisplayString(_ctx.companyName), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsSyndicatedBadge2.mjs.map
